define([], function () {
	'use strict';

	document.getElementById('root').addEventListener('scroll', function (e) {

		var studentSelectionFilterSectionElement = document.getElementById('student_selection_filter_section');

		if (e.target.scrollTop > 120) {
			//42
			if (studentSelectionFilterSectionElement) {
				studentSelectionFilterSectionElement.style.position = 'fixed';
				studentSelectionFilterSectionElement.style.marginTop = '4rem';
				studentSelectionFilterSectionElement.style.height = window.innerHeight + 'px';
			}
		} else if (e.target.scrollTop < 120) {
			if (studentSelectionFilterSectionElement) {
				studentSelectionFilterSectionElement.style.position = 'relative';
				studentSelectionFilterSectionElement.style.marginTop = '0rem';
			}
		}
	});
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/utils/elementStyleChanges.js
// module id = 1182
// module chunks = 0